/**
 * Get unique hash from string
 */
export const hashString = (string: string): number => {
  return string.split('').reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0);
    return a & a;
  }, 0);
};
